// extracted by mini-css-extract-plugin
export default {"topTabs":"index_topTabs__s9NAH"};